module.exports = __webpack_public_path__ + "img/false-god-of-death.aec62fee.jpg";